import React from 'react';

import CloseIcon from './icons/CloseIcon';

const Modal = ({
  children = null,
  onClose = () => { },
  statusModal = false,
}) => {
  const showHideClassName = statusModal ? 'modal show' : 'modal hide';
  const handleOnClick = (e) => {
    e.preventDefault();
    onClose();
  };
  return (
    <div className={showHideClassName}>
      <section className="modalMain">
        <a href="?modalName" className="close" onClick={handleOnClick}>
          <CloseIcon />
        </a>
        {children}
      </section>
    </div>
  );
};
export default Modal;
